import { Fragment, h } from "preact";
import { useContext, } from "preact/hooks";
import { Button, Grid, Tooltip, Typography } from "@mui/material";

import ErrorIcon from "@mui/icons-material/Error";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import palette from "../../theme/palette";
import { AppContext } from "../../AppContext";
import CardTemplate from "../Common/CardTemplate";

export default function DealStatusCard({ state, uid, mode }) {
    const app = useContext(AppContext);

    return (
        <CardTemplate
            title="Statut du dossier de vente"
            content={<Fragment>
                <Grid container >
                    <Grid item xs={4}>
                        <Typography variant="body1">Mandat</Typography>
                    </Grid>
                    <Grid item xs={4}>
                        {state.actualDeal && state.actualDeal.mandate ? (

                            <CheckCircleIcon
                                style={{
                                    color: palette.success.main,
                                }}
                            />

                        ) : (
                            <Tooltip title="En attente de signature">
                                <ErrorIcon style={{
                                    color: palette.warning.main,
                                }} />
                            </Tooltip>
                        )}
                    </Grid>
                    <Grid item xs={4}>
                        {mode == "V" && state.actualDeal.mandate && <Button
                            style="width: 100%"
                            variant="contained"
                            onClick={() => {
                                app.refPopUp.current.handleChangeState(
                                    {
                                        opened: true,
                                        type: "035",
                                        params: {
                                            uid: uid
                                        }
                                    })
                            }}>
                            Résilier
                        </Button>}
                    </Grid>
                </Grid>
                <Grid container style="margin-top: 10px">
                    <Grid item xs={4}>
                        <Typography variant="body1">{state.actualDeal && state.actualDeal.pub ? "En vente" : "Publiable"}</Typography>
                    </Grid>
                    <Grid item xs={2}>
                        {state.actualDeal && state.actualDeal.pub ? (
                            <CheckCircleIcon
                                style={{
                                    color: palette.success.main,
                                }}
                            />

                        ) : (
                            <Tooltip title="En attente de publication">
                                <ErrorIcon style={{
                                    color: palette.warning.main,
                                }} />
                            </Tooltip>
                        )}
                    </Grid>
                    <Grid item xs={6}>
                        {state.actualDeal.psfp && <Typography variant="h5">
                            {/* <a href={`/publicpage/${uid}`}>{state.actualDeal.pub ? "Voir en ligne" : "Prévisualiser"}</a> */}
                            <Button
                                style="width: 100%"
                                onClick={() => { window.location.href = `/publicpage/${uid}` }}
                            >
                                {state.actualDeal.pub ? "Voir en ligne" : "Prévisualiser"}
                            </Button>
                        </Typography>}
                        {!state.actualDeal.psfp && <Typography variant="body1">
                           <em>Il faut une description, un prix et une photo pour voir la fiche du bien</em>
                        </Typography>}
                    </Grid>
                </Grid>
            </Fragment>
            }
        />)



}